module.exports = __webpack_public_path__ + "img/logo-splash-screen.8132c9ff.svg";